import useNativeInput from '../useNativeInput'
import { withHooks } from '../../hoc'
import RawSelect from './RawSelect'

export default withHooks(useNativeInput)(RawSelect)
